<template>
	<el-container class="pages-common pre-tax-index">
		<leftNav />
		<el-main class="main-body" v-loading="loading" element-loading-text="导入中,请稍候"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(238, 238, 238, 0.9)">
			<div class="page-header">
				<div class="title">黑名单人员</div>
				<el-form :inline="true" :model="formInline" class="demo-form-inline" style="display: inline-block">
					<el-form-item label="黑名单人员查询">
						<el-input v-model.trim="formInline.key" placeholder="姓名/工号/身份证号码/备注" clearable></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="small" @click="submitFn">查 询</el-button>
						<el-button type="warning" size="small" @click="resetFn">重 置</el-button>
					</el-form-item>
					<div class="operation-button">
						<el-button type="primary" size="small" @click="dialogVisible = true;">新 增</el-button>
						<el-button type="success" size="small" @click="exportExcel">导 出</el-button>
					</div>
				</el-form>
			</div>
			<div class="page-main">
				<el-table :data="tableList" stripe border size="small" style="width: 100%">
					<el-table-column prop="" label="操作" width="90">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" :disabled="!scope.row.canDelete"
								@click="deleteBlackItem(scope.row.id,scope.$index)">删 除</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="empName" label="姓名" width="150">
					</el-table-column>
					<el-table-column prop="empNo" label="工号" width="120">
					</el-table-column>
					<el-table-column prop="idCard" label="身份证号码" width="200">
					</el-table-column>
					<el-table-column prop="createTime" label="导入时间" width="170">
					</el-table-column>
					<el-table-column prop="createEmpName" label="导入人员" width="150">
					</el-table-column>
					<el-table-column prop="remark1" label="备注">
					</el-table-column>

				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-main>

		<el-dialog title="新增黑名单" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="add-black-list">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
					<el-form-item label="姓名" prop="empName">
						<el-input v-model.trim="ruleForm.empName"></el-input>
					</el-form-item>
					<el-form-item label="工号" prop="empNo">
						<el-input v-model.trim="ruleForm.empNo"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" prop="idCard">
						<el-input v-model.trim="ruleForm.idCard"></el-input>
					</el-form-item>

					<el-form-item label="备注" prop="remark1">
						<el-input type="textarea" v-model.trim="ruleForm.remark1"></el-input>
					</el-form-item>
					<el-form-item>
						<div style="text-align: center;padding-right: 80px;">
							<el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
							<el-button @click="resetForm('ruleForm')">取 消</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>


	</el-container>
</template>

<script>
	import leftNav from "../components/nav.vue";
	import rootUrl from "../utils/api";
	import {
		blackListQuery,
		addBlackList,
		deleteBlackList,
		blacklistExcel
	} from "../api/index";
	export default {
		components: {
			leftNav,
		},
		data() {
			return {
				// uploadUrl: rootUrl + "/blacklist-charge/upload",
				// myHeaders: {
				// 	token: this.$store.state.loginToken,
				// },
				// fileList: [],
				loading: false,
				formInline: {
					key: '',
				},
				tableList: [],
				dialogVisible: false,
				ruleForm: {
					empName: "",
				},
				rules: {
					empName: [{
						required: true,
						message: '请输入添加黑名单员工的姓名',
						trigger: 'blur'
					}],
					empNo: [{
						required: true,
						message: '请输入添加黑名单员工的工号',
						trigger: 'blur'
					}],
					idCard: [{
						required: true,
						message: '请输入添加黑名单员工的身份证编号',
						trigger: 'blur'
					}],
					remark1: [{
						max: 50,
						message: '备注信息控制在50个字符类',
						trigger: 'blur'
					}]
				},
				pageSize: 10,
				currentPage: 1,
				total: 1
			}
		},
		mounted() {
			document.title = "黑名单人员";
			this.queryBlackList();
		},
		methods: {
			// 获取列表数据
			queryBlackList() {
				let data = {
					"current": this.currentPage,
					"size": this.pageSize
				}
				if (this.formInline.key) {
					data.key = this.formInline.key
				}

				blackListQuery(data).then(res => {
					// console.log(res)
					if (this.currentPage == 1) {
						this.total = res.data.total;
					}
					this.tableList = res.data.rows;
				}).catch(err => {
					console.log(err)
				})
			},
			// 查询
			submitFn() {
				this.currentPage = 1;
				this.queryBlackList();
			},
			// 重置
			resetFn() {
				this.formInline = {
					key: ''
				};
				this.currentPage = 1;
				this.queryBlackList();
			},
			// 改变每页显示条数
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.queryBlackList();
			},
			// 改变当前显示页数
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryBlackList();
			},
			// 添加黑名单
			addBlackItem() {
				let data = this.ruleForm;
				addBlackList(data).then(res => {
					if (res.code == 200) {
						this.$message.success('添加成功！');
						this.resetForm('ruleForm');
						this.queryBlackList();
					} else {
						this.$message.error(res.message);
					}

				}).catch(err => {
					console.log(err);
				})
			},
			// 删除黑名单
			deleteBlackItem(id, index) {
				this.$confirm('此操作将该人员从黑名单列表删除, 是否继续?', '提示', {
					closeOnClickModal:false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {
						id: id
					}
					deleteBlackList(data).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功！');
							this.tableList.splice(index, 1);
							if (this.tableList.length == 0) {
								this.queryBlackList();
							}
						} else {
							this.$message.error(res.message);
						}
					
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});

			},
			//提交添加黑名单人员
			submitForm(formName) {
				console.log(this.$refs[formName])
				this.$refs[formName].validate((valid) => {
					console.log(valid)
					if (valid) {
						this.addBlackItem();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 关闭添加黑名单
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false;
			},


			//导出表格
			exportExcel() {
				this.loading = true;
				//blacklistExcel
				blacklistExcel().then(res => {
					this.loading = false;
					const a = document.createElement("a");
					const url = window.URL.createObjectURL(res);
					const filename = '黑名单人员导出.xlsx';
					a.href = url;
					a.download = filename;
					a.click();
					window.URL.revokeObjectURL(url);
					a.remove();
				}).catch(err => {
					this.loading = false;
					console.log(err);
				})
			}
		}
	}
</script>

<style>
</style>
